import { WhiteSelect } from '@features/ui-form/components/Select';
import { useTranslation } from 'next-i18next';
import { ChangeEvent } from 'react';

interface SstSortSelectProps {
  sort: { field: string; order: 'ASC' | 'DESC' };
  onSortChange: (field: string, order: 'ASC' | 'DESC') => void;
}

export function SstSortSelect({ sort, onSortChange }: SstSortSelectProps) {
  const { t } = useTranslation('common');

  const sortOptions = [
    { label: t('ssts.sort.newest'), value: '-createdAt' },
    { label: t('ssts.sort.latest'), value: 'createdAt' },
    { label: t('ssts.sort.spaceObjectNameAZ'), value: 'spaceObject.name' },
    { label: t('ssts.sort.spaceObjectNameZA'), value: '-spaceObject.name' },
    { label: t('ssts.sort.comments'), value: '-commentsCount' },
  ];

  const currentValue = sort.order === 'DESC' ? `-${sort.field}` : sort.field;

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const isDesc = e.target.value.startsWith('-');
    const field = isDesc ? e.target.value.slice(1) : e.target.value;
    const order = isDesc ? 'DESC' : 'ASC';
    onSortChange(field, order);
  };

  return (
    <WhiteSelect
      clearable={false}
      value={currentValue}
      onChange={handleChange}
      options={sortOptions}
      placeholder={t('label.sortBy')}
    />
  );
}
